import React from 'react';
import { useDispatch } from 'react-redux';
import { setTheme } from '../store/themeSlice';
import './ThemeSelector.css';

// Import pokeball sprites
import pokeballSprite from '../assets/pokeballs/poke-ball.png';
import greatballSprite from '../assets/pokeballs/great-ball.png';
import ultraballSprite from '../assets/pokeballs/ultra-ball.png';
import premierballSprite from '../assets/pokeballs/premier-ball.png';
import masterballSprite from '../assets/pokeballs/master-ball.png';

const themes = {
  pokeball: {
    name: 'Pokéball',
    sprite: pokeballSprite,
    colors: {
      primary: '#f8f9fa',      // light gray background
      secondary: '#fa5252',    // more vibrant red navbar
      accent: '#495057',       // dark gray text
      text: '#495057'          // dark gray text on white bg
    }
  },
  greatball: {
    name: 'Great Ball',
    sprite: greatballSprite,
    colors: {
      primary: '#4dabf7',      // softer blue background
      secondary: '#f8f9fa',    // light gray navbar
      accent: '#495057',       // dark gray text
      text: '#f8f9fa'          // light gray text on blue bg
    }
  },
  ultraball: {
    name: 'Ultra Ball',
    sprite: ultraballSprite,
    colors: {
      primary: '#343a40',      // softer black background
      secondary: '#ffd43b',    // warm yellow navbar
      accent: '#f8f9fa',       // light gray text
      text: '#ffd43b'          // warm yellow text on black bg
    }
  },
  premierball: {
    name: 'Premier Ball',
    sprite: premierballSprite,
    colors: {
      primary: '#fa5252',      // more vibrant red background
      secondary: '#f8f9fa',    // light gray navbar
      accent: '#495057',       // dark gray text
      text: '#f8f9fa'          // light gray text on red bg
    }
  },
  masterball: {
    name: 'Master Ball',
    sprite: masterballSprite,
    colors: {
      primary: '#845ef7',      // softer purple background
      secondary: '#f8f9fa',    // light gray navbar
      accent: '#f8f9fa',       // light gray text
      text: '#f8f9fa'          // light gray text on purple bg
    }
  }
};

function ThemeSelector({ currentTheme }) {
  const dispatch = useDispatch();

  const handleThemeChange = (themeKey) => {
    dispatch(setTheme(themeKey));
  };

  return (
    <div className="theme-selector">
      <div className="theme-options">
        {Object.entries(themes).map(([themeKey, theme]) => (
          <button
            key={themeKey}
            className={`theme-button ${themeKey} ${currentTheme === themeKey ? 'active' : ''}`}
            onClick={() => handleThemeChange(themeKey)}
            title={theme.name}
          >
            <img 
              src={theme.sprite} 
              alt={theme.name}
              className="pokeball-sprite"
            />
          </button>
        ))}
      </div>
    </div>
  );
}

export default ThemeSelector;
export { themes }; 